import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './styles/responsive.css'
import './styles/mobile.css'
import App from './App.tsx'


// Error handling for module loading
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('Failed to fetch dynamically imported module')) {
    // Error handling: Failed to load module
    // Common causes: incorrect import path, missing module, or syntax error
  }
});

// Catch unhandled promise rejections
window.addEventListener('unhandledrejection', (_e) => {
  // Error handling: Unhandled Promise Rejection
});


const rootElement = document.getElementById('root');
if (!rootElement) {
  // Error handling: Root element not found
  document.body.innerHTML = '<div style="color: red; padding: 20px;">Error: Root element not found. Check index.html</div>';
} else {
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}
